import React from 'react'

import cn from 'classnames'

import './index.scss'

const VideoModal = ({ src = '', closePlayer = () => {} }) => {
  return (
    <div className="video-modal-container">
      <div className="overlay" onClick={ () => closePlayer() } />
      <div className="modal">
        <video controls>
          <source src={src} type="video/mp4"></source>
        </video>
      </div>
    </div>
  )
}

export default VideoModal
